export default __webpack_public_path__ + "static/media/ic_weth_40.334ca16a.svg";